import {Radio} from 'antd';

const RadioButton = ({className, ...props}) => {
  return <Radio.Button {...props} />;
}

export default RadioButton;